import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getEndpointSectionUtil from 'modules/section/utils/get-endpoint/index.js'
import isNewReduxUtil from 'modules/redux/utils/is-new/index.js'
import { logUtil } from 'packages/src'

/**
 * Loads the comments of the given instance.
 * @param  {Instance} instance
 * @returns {Function}
 */
export default function loadInstanceAssociationsSectionAction (instance) {
  return (dispatch) => {
    const path = getPathReduxUtil(instance)
    if (isNewReduxUtil(instance)) {
      logUtil('loadInstanceAssociationsSectionAction').debug('[noop] new instance')
      return
    }

    dispatch(
      loadLegacyReduxAction({
        endpoint: getEndpointSectionUtil(instance) + '/associations',
        path
      })
    )
  }
}
